import React from 'react';
import chroma from 'chroma-js';

export default class LayerGUI extends React.Component {

  constructor(props) {
    super(props);
    this.turns = 0;
    this.layerImages = {};
    this.state = { colorPosition: [0, 0], pickingColor: false };
    this.previewCanvasRef = React.createRef();
  }

  componentWillUpdate(nextProps) {
    const { activeLayer } = this.props;
    if (!activeLayer || !activeLayer.color && nextProps.activeLayer && nextProps.activeLayer.color) {
      this.setState({
        colorPosition: this.getPositionFromColor(nextProps.activeLayer.color)
      })
    }
  }

  componentDidUpdate() {
    this.updateStrokePreview();
  }

  componentDidMount() {
    this.updateStrokePreview();
  }

  updateStrokePreview = () => {
    const { activeLayer } = this.props;
    if (!this.previewCanvasRef.current || !activeLayer) return;

    const canvas = this.previewCanvasRef.current;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;

    // Clear canvas
    ctx.clearRect(0, 0, width, height);

    // Draw preview stroke
    ctx.strokeStyle = activeLayer.color || '#6366f1';
    ctx.fillStyle = activeLayer.color || '#6366f1';
    ctx.lineWidth = activeLayer.width || 5;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';

    // Draw a wavy line to show the stroke
    ctx.beginPath();
    const startX = 20;
    const startY = height / 2;
    const amplitude = 15;
    const frequency = 0.02;

    ctx.moveTo(startX, startY);
    for (let x = startX; x < width - 20; x += 2) {
      const y = startY + Math.sin((x - startX) * frequency) * amplitude;
      ctx.lineTo(x, y);
    }

    if (activeLayer.fill) {
      // If fill is enabled, draw a closed shape
      ctx.closePath();
      ctx.fill();
    } else {
      ctx.stroke();
    }
  }

  getLayerImage = () => {
    if (this.palletImage) return this.palletImage;
    const c = document.createElement('canvas');
    c.height = c.width = 210;
    const ctx = this.wheelCtx = c.getContext('2d');
    const center = c.height / 2;
    const radius = 100;

    const color = [255, 0, 0];
    const inc = 2 * Math.PI / 256;

    ctx.strokeStyle = 'rgb(55,55,55)';
    ctx.lineWidth = 4;
    ctx.arc(center, center, radius, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.lineWidth = 1;

    for (var a = 0, i = 0; a < 2 * Math.PI; a += inc) {
      ctx.beginPath();
      ctx.moveTo(center, center);
      ctx.strokeStyle = ctx.fillStyle = `hsl(${a.toPrecision(4)}rad,100%,50%)`);
      ctx.arc(center, center, radius, a, a + inc);
      ctx.fill();
      ctx.stroke();
    }

    ctx.beginPath();
    const g = ctx.createRadialGradient(center, center, 0, center, center, 100);
    g.addColorStop(0, 'rgba(0,0,0,1)');
    g.addColorStop(0.4, 'rgba(0,0,0,0)');
    g.addColorStop(0.4, 'rgba(255,255,255,0)');
    g.addColorStop(0.7, 'rgba(255,255,255,0.5');
    g.addColorStop(1.0, 'rgba(255,255,255,1)');
    ctx.fillStyle = g;
    ctx.arc(center, center, radius, 0, 2 * Math.PI);
    ctx.fill();

    return (this.palletImage = c.toDataURL());
  }

  getPositionFromColor = color => {
    const pos = [0, 0];

    if (!color) return pos;
    console.log(color)
    const [r, g, b] = color
      .slice(1)
      .toUpperCase()
      .match(/([A-Z0-9]{2})/g)
      .map(v => parseInt(v, 16));
    // Brightness as simple average of all values linearly averaged
    const brightness = ((r+b+g)/(3*255))**2;
    // Percentages, just to normalize magnitudes for calculations below
    const n_r = (r / 255);
    const n_b = (b / 255);
    const n_g = (g / 255);
    // Creating directional vectors of each color in its associated direction (RGB) in HSB space
    const ar = [n_r, 0];
    // Unsure why we have to use the seemingly opposite angle-offsets for green and blue
    // only thing I can think of is that HSB runs CLOCKWISE in its orientation?
    const ab = [n_b * Math.cos(Math.PI*4/3), n_b * Math.sin(Math.PI*4/3)];
    const ag = [n_g * Math.cos(Math.PI*2/3), n_g * Math.sin(Math.PI*2/3)];
    // Final directional vector in HSB space
    const v = [
      ar[0] + ab[0] + ag[0],
      ar[1] + ab[1] + ag[1]
    ];

    const x = brightness * 100 * Math.cos(Math.atan2(v[1], v[0]));
    const y = brightness * 100 * Math.sin(Math.atan2(v[1], v[0]));

    return [parseFloat(x.toPrecision(4)), parseFloat(y.toPrecision(4))];
  }

  getColorFromPosition = (pos) => {
    const [x, y] = (pos || this.state.colorPosition);
    const [r, g, b] = this.wheelCtx.getImageData(105+x, 105+y, 1, 1).data;

    const hexified = [r,g,b]
      .map(x => parseInt(x.toPrecision(4), 10).toString(16))
      .map(v => v.length < 2 ? new Array(2 - v.length).fill(0).join('') + v : v)
    const hex = `#${hexified.join('')}`;

    return hex;
  }

  setLayerWidth = e => {
    this.props.onSetLayerStrokeWidth(parseInt(e.target.value, 10));
  }

  handlePointerDown = e => {
    // Capture the pointer so we get all events even if mouse moves outside
    e.currentTarget.setPointerCapture(e.pointerId);

    this.setState({
      pickingColor: true
    });
  }

  handlePointerMove = e => {
    if (!this.state.pickingColor) return;

    this.setState({
      colorPosition: [
        this.state.colorPosition[0] + e.movementX,
        this.state.colorPosition[1] + e.movementY
      ]
    });
  }

  handlePointerUp = e => {
    if (!this.state.pickingColor) return;

    // Release pointer capture
    if (e.currentTarget.hasPointerCapture(e.pointerId)) {
      e.currentTarget.releasePointerCapture(e.pointerId);
    }

    this.setState({
      pickingColor: false
    }, () => this.props.onSetLayerColor(this.getColorFromPosition()));
  }

  render() {
    const { pickingColor } = this.state;
    const { activeLayer, onSetLayerColor, onToggleLayerFill } = this.props;
    const colorProp = activeLayer ? { color: activeLayer.color } : {}

    return (
      <aside className={activeLayer && !activeLayer.drawing ? 'active' : ''}>
        <h3>Color Picker</h3>
        <div
          style={{ background: `url(${this.getLayerImage()})` }}
          onPointerDown={this.handlePointerDown}
          onPointerMove={this.handlePointerMove}
          onPointerUp={this.handlePointerUp}
        >
          <span
            className="colorPosition"
            style={{
              backgroundColor: this.getColorFromPosition(),
              transform: `translate3d(${this.state.colorPosition[0]}px,${this.state.colorPosition[1]}px,0)`
            }}
          />
        </div>
        <div>
          <h3>Stroke Width</h3>
          <div>
            <input type="range" min="1" max="50" step="1" value={activeLayer && activeLayer.width || 5} onChange={this.setLayerWidth} />
          </div>
          <label>
            <input type="checkbox" checked={activeLayer && activeLayer.fill} onInput={() => onToggleLayerFill()} />
            Fill Shapes
          </label>
          <h3>Preview</h3>
          <div>
            <canvas
              ref={this.previewCanvasRef}
              width={232}
              height={60}
              style={{
                width: '100%',
                height: '60px',
                background: 'var(--neutral-950)',
                borderRadius: 'var(--radius-md)',
                border: '1px solid var(--neutral-700)'
              }}
            />
          </div>
        </div>
      </aside>
    );
  }
}
